import React from 'react';
import { useTranslation } from 'react-i18next';

import { type v2 } from '@deque/billing-service-client';
import {
  Alert,
  AlertActions,
  AlertContent,
  Button
} from '@deque/cauldron-react';

export interface DeleteTeamAlertProps {
  show: boolean;
  team: v2.Team | null;
  onDelete: () => void;
  onCancel: () => void;
}

const DeleteTeamAlert: React.FC<DeleteTeamAlertProps> = ({
  show,
  team,
  onDelete,
  onCancel
}: DeleteTeamAlertProps) => {
  const { t } = useTranslation();

  return (
    <Alert variant="warning" show={show} heading={<>{t('Delete Team')}</>}>
      <AlertContent>
        <p>
          {t(
            'You\'re about to delete the team "{{team_name}}". This action is irreversible and users could lose access to scan entities.',
            { team_name: team?.name }
          )}
        </p>
        <p>{t('For more information, please visit our documentation.')}</p>
      </AlertContent>
      <AlertActions>
        <Button variant="error" onClick={onDelete}>
          {t('Delete')}
        </Button>
        <Button variant="secondary" onClick={onCancel}>
          {t('Cancel')}
        </Button>
      </AlertActions>
    </Alert>
  );
};

export default DeleteTeamAlert;
